import React, { Component } from 'react'
import { Link as RouterLink, withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Text from '../../components/Text'

const ActiveA = styled.a`
  color: var(--green);
  display: flex;
  align-items: center;
  text-decoration: none;
  width: 100%;
  transition: all 0.2s;
  font-size: 1.2rem;
  font-weight: 300;
  height: 3.5rem;
  border-left: 5px solid var(--green);
`

const InactiveA = styled(ActiveA)`
  color: var(--gray);
  border-left: 0 solid transparent;
  &:hover {
    color: var(--${props => props.color || 'blue'});
    border-left: 5px solid var(--${props => props.color || 'blue'});
  }
`

const Icon = styled.div`
  font-size: 1.5rem;
  margin: 0 1rem;
`

const ActiveLink = ActiveA.withComponent(RouterLink)
const InactiveLink = InactiveA.withComponent(RouterLink)

class Link extends Component {
  onClick = () => {
    const { onClick, onCloseMenu, dontCloseMenu } = this.props
    
    if (!dontCloseMenu && onCloseMenu) {
      onCloseMenu()
    }

    if (onClick) {
      onClick()
    }
  }

  render() {
    const { color, icon, str, location, to, href, target } = this.props
    if (href) {
      return (
        <InactiveA target={target} href={href} color={color} onClick={this.onClick}>
          <Icon className={icon} />
          <Text str={str} />
        </InactiveA>
      )
    }
    
    const ChosenLink = location.pathname === to ? ActiveLink : InactiveLink

    return (
      <ChosenLink color={color} to={to || '#'} onClick={this.onClick}>
        <Icon className={icon} />
        <Text str={str} />
      </ChosenLink>
    )
  }
}

export default withRouter(Link)



// WEBPACK FOOTER //
// ./src/components/Menu/Link.js